import { z } from 'zod'

/**
 * The two kinds of work a visit assesses.
 *
 * `SiteRecordKind` is this plus `'site'` (the boundary and the areas, which
 * a visit does not cover on their own). One list, because the phone and the
 * API both filter visits by it, and a third kind added on only one side
 * would record work the other side never asked for.
 */
export const VISIT_KINDS = ['trees', 'irrigation'] as const

export const visitKindSchema = z.enum(VISIT_KINDS)

export type VisitKind = z.infer<typeof visitKindSchema>
